
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c-1.6 0-3.1.7-4 2-1.7-2.2-4.8-2.7-7-1-1.3.9-2 2.4-2 4 0 3 1 4 9 11 8-7 9-8 9-11 0-2.8-2.2-5-5-5z"}})])
          )
        }
      }
    